import {
  GETPATIENTDATASUCCESS,
  GETPATIENTDATAFAILED,
  REMOVEPATIENTDATA,
  GETPATIENTDATAREQ,
  SAVE_LOGGED_USER,
  CLEAR_LOGGED_USER,
} from "../actions/AuthActions";

const initialState = {
  patientData: null,
  loading: false,
  loggedUser: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETPATIENTDATAREQ:
      return {
        ...state,
        loading: true,
      };
    case GETPATIENTDATASUCCESS:
      return {
        ...state,
        patientData: action.payload,
        loading: false,
      };
    case GETPATIENTDATAFAILED:
    case REMOVEPATIENTDATA:
      return {
        ...state,
        patientData: null,
        loading: false,
      };

    case SAVE_LOGGED_USER:
      return { ...state, loggedUser: action.payload };

    case CLEAR_LOGGED_USER:
      return { ...state, loggedUser: action.payload };

    default:
      return state;
  }
};
